import { render, staticRenderFns } from "./AdsMgmt.vue?vue&type=template&id=dad832c4"
import script from "./AdsMgmt.vue?vue&type=script&lang=js"
export * from "./AdsMgmt.vue?vue&type=script&lang=js"
import style0 from "./AdsMgmt.vue?vue&type=style&index=0&id=dad832c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports